import {localizeRepContent} from './rep-content-locales';

export const REP_CONTEXTUAL_TIPS = [
  {
    key: 'share-highlight',
    paths: ['/player-video', '/partner-video'],
    question: 'Sai che puoi condividere un Highlight con un semplice link?',
    detail: 'Rep può mostrarti come creare il collegamento e inviarlo alle persone che scegli.',
    ask: 'Come posso condividere un highlight con un link?'
  },
  {
    key: 'organize-video-folders',
    paths: ['/player-video', '/partner-video'],
    question: 'Sai che puoi dividere video e Highlight in cartelle?',
    detail: 'Puoi organizzare allenamenti, partite e momenti preferiti senza modificare i contenuti.',
    ask: 'Come organizzo video e highlight in cartelle?'
  },
  {
    key: 'pickleball-analysis',
    paths: ['/player-video', '/partner-video', '/player-replayer-tv-home', '/partner-replayer-tv-home'],
    question: 'Sai come funziona l’Analisi Pickleball?',
    detail: 'Rep può spiegarti selezione dello spezzone, costo, elaborazione e risultato.',
    ask: 'Spiegami tutte le fasi di una analisi pickleball'
  },
  {
    key: 'booking-invitations',
    paths: ['/player-calendars', '/player-bookings'],
    roles: [0],
    question: 'Sai che in una prenotazione a invito puoi distinguere partecipanti e ospiti?',
    detail: 'Rep ti spiega chi paga, come invitare e cosa accade se un partecipante deve ricaricare.',
    ask: 'Come funziona una prenotazione a invito?'
  },
  {
    key: 'partner-planning',
    paths: ['/partner-fields', '/partner-bookings', '/partner-services-bookings'],
    roles: [1],
    question: 'Vuoi rendere più semplice la pianificazione di campi e servizi?',
    detail: 'Rep può guidarti nella creazione di slot disponibili e riservati.',
    ask: 'Come faccio a pianificare un campo?'
  }
];

export const findRepContextualTips = (pathname, role, language = 'it') => REP_CONTEXTUAL_TIPS
  .filter(tip => (
    tip.paths.some(path => pathname === path || pathname.startsWith(`${path}/`))
    && (!tip.roles || tip.roles.includes(role))
  ))
  .map(tip => localizeRepContent(tip, 'tips', language));
